import { render, staticRenderFns } from "./SuccessorBlock.vue?vue&type=template&id=9a748e84"
import script from "./SuccessorBlock.vue?vue&type=script&lang=js"
export * from "./SuccessorBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports